import React, { useState } from "react";

const VideoItem = ({ videoUrl, showVideo }) => {
  const [hasError, setHasError] = useState(false);

  if (!showVideo || !videoUrl) {
    return null;
  }

  return (
    <div style={{ marginTop: "12px" }}>
      <h4 style={{ color: "#d9cc2f", marginBottom: "10px" }}>Video Player</h4>

      {!hasError ? (
        <video
          key={videoUrl}
          controls
          playsInline
          preload="metadata"
          style={{
            width: "100%",
            maxWidth: "100%",
            borderRadius: "12px",
            backgroundColor: "#000"
          }}
          onLoadedMetadata={(e) => {
            console.log("VIDEO loaded metadata", {
              duration: e.currentTarget.duration,
              src: e.currentTarget.currentSrc,
            });
          }}
          onCanPlay={(e) => {
            console.log("VIDEO can play", {
              duration: e.currentTarget.duration,
              src: e.currentTarget.currentSrc,
            });
          }}
          onError={(e) => {
            const mediaError = e.currentTarget?.error;
            console.error("VIDEO error", {
              code: mediaError?.code,
              message:
                mediaError?.message ||
                "Video failed to load in browser player",
              src: e.currentTarget?.currentSrc,
            });
            setHasError(true);
          }}
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <div
          style={{
            padding: "16px",
            borderRadius: "12px",
            background: "#1b2431",
            color: "#fff",
            lineHeight: 1.5
          }}
        >
          <p style={{ marginTop: 0, fontWeight: "bold" }}>
            Video se ne može reproducirati u browseru.
          </p>
          <p>
            Stream je dostupan, ali originalni upload najvjerojatnije koristi codec
            koji browser ne podržava.
          </p>
          <p style={{ marginBottom: 0 }}>
            Pričekaj export obrađene verzije ili preuzmi originalni file.
          </p>
        </div>
      )}

      <p style={{ marginTop: "8px", fontSize: "12px", color: "#cfd6e4" }}>
        * Secure stream: Unauthorized downloading is disabled.
      </p>
    </div>
  );
};

export default VideoItem;